import { Preview } from "../../../../types/IAction";
import * as actions from "../../../actions/comisionContactCenter";
import { GetComisionContactCenterConsultar } from "../../../reducers/comisionContactCenter";

export interface ReporteContactCenterDispatcher {
  getConsultarComisiones: (
    periodo: string
  ) => Promise<Preview<GetComisionContactCenterConsultar>>;
}

export const reporteContactCenterDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => ReporteContactCenterDispatcher = dispatch => ({
  getConsultarComisiones: (periodo: string) => {
    return dispatch(actions.getConsultarComisiones(periodo));
  }
});
